<script setup>
import { ref, onUpdated, defineProps, defineEmits } from "vue"
import useStores from "../../use/useStores"

import usePersianTools from "../../use/usePersianTools"
const { convertPersianToEnglish } = usePersianTools()

const props = defineProps({
  storeProps: {
    required: true,
    type: Object,
  },
})

const storeData = ref({
  id: props.storeProps.id,
  commission: "",
  amount_deposited: "",
})

const emit = defineEmits(["update:modelValue", "close"])

const { show, loading, errors, storeSettlement, closeModal } = useStores(
  props,
  emit,
  storeData
)

onUpdated(() => {
  storeData.value = {
    id: props.storeProps.id,
    commission: "",
    amount_deposited: "",
  }
})
</script>

<template>
  <!-- settlement modal  -->
  <b-modal
    v-model="show"
    @close="closeModal()"
    id="showModal"
    hide-footer
    title="تسویه حساب فروشگاه"
    header-class="p-3 bg-light"
    class="v-modal-custom"
    centered
    no-close-on-backdrop
  >
    <b-overlay
      variant="white"
      opacity="0.75"
      blur="2px"
      :show="loading"
      spinner-variant="success"
      rounded="sm"
    >
      <b-card>
        <b-form
          id="settlementform"
          class="tablelist-form"
          autocomplete="off"
          @submit.prevent="storeSettlement"
        >
          <div class="mb-3">
            <label for="storename" class="form-label">مبلغ واریزی</label>
            <input
              type="text"
              id="storename"
              class="form-control"
              placeholder="مبلغ واریز شده"
              v-model="storeData.amount_deposited"
              @input="
                convertPersianToEnglish(
                  $event.target.value,
                  storeData,
                  'amount_deposited'
                )
              "
            />
            <div class="invalid-feedback text-primary text-opacity-75">
              <span>{{ storeData.amount_deposited_words }}</span>
            </div>
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.amount_deposited">
                <span>{{ errors.amount_deposited[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="commission-id" class="form-label">مبلغ کمیسیون</label>
            <input
              type="text"
              id="commission-id"
              class="form-control"
              placeholder="مبلغ کمیسیون کسر شده"
              v-model="storeData.commission"
              @input="
                convertPersianToEnglish(
                  $event.target.value,
                  storeData,
                  'commission'
                )
              "
            />
            <div class="invalid-feedback text-primary text-opacity-75">
              <span>{{ storeData.commission_words }}</span>
            </div>
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.commission">
                <span>{{ errors.commission[0] }}</span>
              </div>
            </div>
          </div>

          <div class="hstack gap-2 justify-content-end">
            <b-button
              type="button"
              id="closemodal"
              variant="light"
              @click="closeModal"
            >
              بستن
            </b-button>
            <b-button type="submit" variant="success"> ثبت </b-button>
          </div>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
